import {Injectable} from '@angular/core';
import {ApiService} from "./api.service";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {Pagination} from "../models/pagination";
import {OfferAttributeType} from "../models/offer-attribute-type";
import {AllPaginateItemsAPI} from "@core/shared/models/all-paginate-items-api";

@Injectable({
    providedIn: 'root'
})
export class OfferAttributeTypeService {

    constructor(
        private _apiService: ApiService,
        private _httpClient: HttpClient
    ) {
    }

    public getItemsAPI(): Observable<OfferAttributeType[]> {

        const params: string[] = [
            `enabled[eq]=1`
        ];

        return new AllPaginateItemsAPI<OfferAttributeType>(this.getPaginationItemsAPI.bind(this), params).request$;
    }

    public getPaginationItemsAPI(params?: string[]): Observable<Pagination<OfferAttributeType>> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        let url: string = `${this._apiService.getApiUrl(false, true)}/offerAttributes/types`;

        params = params || [];

        if (params.length > 0) {

            url = `${url}?${params.join('&')}`;
        }

        return this._httpClient.get<Pagination<OfferAttributeType>>(url, {
            headers: headers
        });
    }
}
